import { render, staticRenderFns } from "./app-icon.vue?vue&type=template&id=7c19b398&scoped=true&"
import script from "./app-icon.vue?vue&type=script&lang=js&"
export * from "./app-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c19b398",
  null
  
)

export default component.exports